"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
function dataToMessage(data) {
    if (typeof data === 'string') {
        return data;
    }
    else if (data.error && data.error.message) {
        return data.error.message;
    }
    else {
        return JSON.stringify(data);
    }
}
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(status, data, message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message || dataToMessage(data)) || this;
        _this.status = status;
        _this.data = data;
        _this.name = 'HTTP_ERROR';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return HttpError;
}(Error));
exports.HttpError = HttpError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSHR0cEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb250ZW50L21vZGVsL0h0dHBFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxTQUFTLGFBQWEsQ0FBQyxJQUFTO0lBQzlCLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1FBQzVCLE9BQU8sSUFBSSxDQUFDO0tBQ2I7U0FBTSxJQUFJLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLEVBQUU7UUFDM0MsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztLQUMzQjtTQUFNO1FBQ0wsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQzdCO0FBQ0gsQ0FBQztBQUVEO0lBQStCLDZCQUFLO0lBR2xDLG1CQUFtQixNQUFjLEVBQVMsSUFBUyxFQUFFLE9BQWdCOztRQUFyRSxZQUNFLGtCQUFNLE9BQU8sSUFBSSxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUMsU0FFdEM7UUFIa0IsWUFBTSxHQUFOLE1BQU0sQ0FBUTtRQUFTLFVBQUksR0FBSixJQUFJLENBQUs7UUFGbkMsVUFBSSxHQUFHLFlBQVksQ0FBQztRQUlsQyxNQUFNLENBQUMsY0FBYyxDQUFDLEtBQUksRUFBRSxXQUFXLFNBQVMsQ0FBQyxDQUFDOztJQUNwRCxDQUFDO0lBQ0gsZ0JBQUM7QUFBRCxDQUFDLEFBUEQsQ0FBK0IsS0FBSyxHQU9uQztBQVBZLDhCQUFTIn0=